import { useMutation } from 'react-query';
import { groupRequest } from 'src/models/CRM';
import { updateGroup } from 'src/services/CRM/groups';

export default function UpdateGroup() {
  return useMutation(({ id, data }: { id: number; data: groupRequest }) =>
    updateGroup(id, data)
  );
}
